export default function MiddleCTA() {
  return (
    <section className="py-20 md:py-28 px-4 md:px-6 bg-background-100">
      <div className="max-w-4xl mx-auto">
        {/* Image container */}
        <div className="rounded-3xl overflow-hidden mb-12 md:mb-16 px-[4%]">
          <img
            src="https://readdy.ai/api/search-image?query=Overhead%20flat%20lay%20composition%20of%20a%20laptop%20displaying%20a%20spreadsheet%20alongside%20scattered%20fashion%20accessories%20including%20a%20woven%20straw%20hat%20delicate%20gold%20chain%20necklace%20and%20round%20sunglasses%20arranged%20on%20a%20warm%20terracotta%20linen%20surface%20with%20soft%20diffused%20window%20light%20creating%20gentle%20shadows%20editorial%20lifestyle%20photography%20with%20organic%20textures%20and%20warm%20earthy%20tones&width=1200&height=600&seq=mid-cta-img-v2-02&orientation=landscape"
            alt="AllChinaBuy Spreadsheet curated product collection"
            title="AllChinaBuy Spreadsheet Product Collection"
            className="w-full aspect-[2/1] object-cover rounded-2xl"
            loading="lazy"
          />
        </div>

        {/* Text */}
        <div className="text-center px-4">
          <p className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-[1.25] mb-4">
            Discover products faster with the{" "}
            <span className="italic font-normal text-foreground-600">allchinabuy sheet</span>
          </p>
          <p className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-[1.25] mb-10">
            trusted by thousands of shoppers
          </p>

          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-10 py-4 bg-primary-500 text-background-50 rounded-full text-base font-semibold hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
          >
            Explore Full Spreadsheet
            <i className="ri-arrow-right-up-line w-5 h-5 flex items-center justify-center"></i>
          </a>
        </div>
      </div>
    </section>
  );
}